import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";
import LinkedText from "./LinkedText";

const Card = styled(Link)`
  display: block;
  padding: 12px 16px;
  margin-bottom: 8px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.15s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 1.05em;
  margin-bottom: 4px;
`;

const Description = styled.div`
  color: #666;
  font-size: 0.9em;
  margin-bottom: 4px;
`;

const Footer = styled.div`
  display: flex;
  gap: 12px;
  font-size: 0.8em;
  color: #888;
`;

const FooterItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

/**
 * Generic card used for lists, map CTA, and any other "tile pointing somewhere".
 *
 * For a SavedSearch list, pass `to` + `title` + `description` + `cityLabel`.
 * For the map CTA, pass `to` + `title` + `description` + `icon`.
 */
const ListCard = ({ to, title, description, cityLabel, icon, iconLabel }) => (
  <Card to={to}>
    <Title>{title}</Title>
    {description && (
      <Description>
        {typeof description === "string" ? (
          <LinkedText text={description} />
        ) : (
          description
        )}
      </Description>
    )}
    {(cityLabel || iconLabel) && (
      <Footer>
        {cityLabel && (
          <FooterItem>
            <i className="fas fa-map-marker-alt" /> {cityLabel}
          </FooterItem>
        )}
        {iconLabel && (
          <FooterItem>
            {icon && <i className={icon} />} {iconLabel}
          </FooterItem>
        )}
      </Footer>
    )}
  </Card>
);

ListCard.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  cityLabel: PropTypes.string,
  icon: PropTypes.string,
  iconLabel: PropTypes.string,
};

export default ListCard;
